module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAPRJREFUKBWdkdENgjAQhq1uQMoAJpCQsACPGlzC1VyAIYzBR8K7CW8OUHbA+0pLsEKiXtLQ+/t/3PWqhmHYbf6ILUyappckSa5FUei1f3CGBy8eC0rVvaxj3/e3JRiNMzx4J1BrfVZKPUTMQ3gG5XjwAiox2zsuGEoMrpKHyqZp+jeQZA5L2qFJZK7SBCFOFUkIYGPMXbYZuUQXx/HBVxolNxyf/PK1U/WAb1VyqtEqKwsHJtr4HGw8xGS5E+2x1qZtK4aQjNwOgnuxX4ItKK1UvpKH6IIAjqLoNIMrdAuK+JRVhxAGom1b4yrXeNE+ngPxm3gBnYm64hzJA8YAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/close.png
// module id = 119
// module chunks = 0